import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import ThemesPanelFull from './ThemesPanelFull';
import ThemesPanelNarrow from './ThemesPanelNarrow';

const ThemesPanel = ({ configuration }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: ThemesPanelFull, narrow: ThemesPanelNarrow }}
  />
);

export default ThemesPanel;
